module.exports = __webpack_public_path__ + "img/help_delete_account01.970a10ea.png";